.section {
  padding: 16px 0;
  border-bottom: 1px solid #e0e0e0;
}

.title {
  padding: 0 16px;
  font-size: var(--font-size-sm);
}

.item {
  padding-top: 10px;
}

.text {
  display: block;
  padding: 0 16px;
  font-size: 13px;
}

.link {
  display: block;
  padding: 0 16px;
  font-size: 13px;
}

.time {
  display: block;
  padding-right: 16px;
  font-size: 13px;
  line-height: 1.5;
  color: #999;
  text-align: right;
}
